import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import Attachment from '../../../Attachments/Attachment';
const MediaView = _ref => {
  let {
    name,
    wrapType,
    type,
    url,
    thumbUrl,
    pluginOptions
  } = _ref;
  const onPreview = useCallback(file => {
    pluginOptions.events.emit('previewMedia', file.url, file.name);
  }, [pluginOptions]);
  return /*#__PURE__*/React.createElement("span", {
    className: "tap-editor-media",
    "data-wrapType": wrapType,
    "data-name": name,
    "data-type": type,
    "data-url": url,
    "data-thumbUrl": thumbUrl
  }, /*#__PURE__*/React.createElement(Attachment, {
    file: {
      name,
      type,
      url
    },
    showMeta: false,
    onPreview: onPreview
  }));
};
MediaView.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  thumbUrl: PropTypes.string,
  wrapType: PropTypes.string
};
MediaView.defaultProps = {
  name: EMPTY_STRING,
  type: EMPTY_STRING,
  url: EMPTY_STRING,
  thumbUrl: EMPTY_STRING,
  wrapType: 'inline-block'
};
export default /*#__PURE__*/React.memo(MediaView);